// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {getFirestore} from 'firebase/firestore'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDj4r8fyoXHKCcJtIj07M81D58er_a-xJ8",
  authDomain: "madi-production.firebaseapp.com",
  projectId: "madi-production",
  storageBucket: "madi-production.appspot.com",
  messagingSenderId: "945621625684",
  appId: "1:945621625684:web:23aa8589e6cc5aa23ff6c1",
  measurementId: "G-BP3217P2G5"
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
export const fs = getFirestore(app);
export default app;